import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const formErrorsSlice = createSlice({
  name: 'formErrors',
  initialState,
  reducers: {
    setFormErrors(state, action) {
      const { id, errors } = action.payload;
      const systemErrors = errors.filter((e) => !e.field);
      const requiredErrors = errors.filter((e) => e.code === 21);
      const otherErrors = errors.filter(
        (e) => e.field && e.code !== 21,
      );
      state[id] = { systemErrors, requiredErrors, otherErrors };
    },
    removeFormErrors(state, action) {
      const { id } = action.payload;
      state[id] = {};
    },
    cleanFormErrorsSlice() {
      return initialState;
    }
  },
});

export const { cleanFormErrorsSlice, removeFormErrors, setFormErrors } = formErrorsSlice.actions;

export default formErrorsSlice.reducer;
